import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const StatusIndicator = ({
    status = 'connect',
    text = null,
    size = 'medium',
    sx = {},
    textColor = null,
    ...props
}) => {
    const theme = useTheme();
    const { t } = useTranslation();

    // Default text based on status (번역 키 사용)
    const getDefaultText = () => {
        switch (status) {
            case 'connect':
            case 'connecting':
                return t('connecting');
            case 'disconnect':
                return t('disconnected');
            case 'connected':
                return t('connected');
            case 'error':
                return t('error');
            case 'warning':
                return t('warning');
            case 'success':
                return t('success');
            default:
                return t('status');
        }
    };

    // Get colors and styles based on status
    const getStatusStyles = () => {
        switch (status) {
            case 'connect':
            case 'connecting':
                return {
                    backgroundColor: '#00a6ff',
                    color: theme.palette.figma.buttonText,
                    text: text ?? getDefaultText(),
                };
            case 'disconnect':
                return {
                    backgroundColor: theme.palette.figma.white[30],
                    color: theme.palette.figma.white[30],
                    text: text ?? getDefaultText(),
                };
            case 'connected':
            case 'success':
                return {
                    backgroundColor: theme.palette.figma.success,
                    color: theme.palette.figma.white[100],
                    text: text ?? getDefaultText(),
                };
            case 'error':
                return {
                    backgroundColor: theme.palette.figma.error,
                    color: theme.palette.figma.white[100],
                    text: text ?? getDefaultText(),
                };
            case 'warning':
                return {
                    backgroundColor: theme.palette.figma.warning,
                    color: theme.palette.figma.white[100],
                    text: text ?? getDefaultText(),
                };
            default:
                return {
                    backgroundColor: theme.palette.figma.white[30],
                    color: theme.palette.figma.white[30],
                    text: text ?? getDefaultText(),
                };
        }
    };

    const statusStyles = getStatusStyles();

    const containerStyles = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '5px',
        padding: size === 'small' ? '4px 8px' : '4px 10px',
        borderRadius: '8px',
        backgroundColor: statusStyles.backgroundColor,
        transition: 'all 0.2s ease-in-out',
        ...sx,
    };

    const textStyles = {
        fontFamily: 'Pretendard, sans-serif',
        fontSize: size === 'small' ? '10px' : '12px',
        fontWeight: 500, // Medium
        color: textColor || statusStyles.color,
        letterSpacing: '-0.36px',
        whiteSpace: 'nowrap',
        lineHeight: 'normal',
    };

    return (
        <Box sx={containerStyles} {...props}>
            <Typography sx={textStyles}>{statusStyles.text}</Typography>
        </Box>
    );
};

export default StatusIndicator;
